// PricingPlans.jsx
import React from "react";
import { Card, Row, Col, Typography, Button } from "antd";
import {
    UserOutlined,
    ShopOutlined,
    LineChartOutlined
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const profiles = [
    {
        label: "Producteur Agricole",
        description: "Optimisez vos rendements et accédez à des outils d'aide à la décision.",
        icon: <UserOutlined style={{ fontSize: 24, color: "#52c41a" }} />,
        route: "/pricing/producers"
    },
    {
        label: "Spéculateur Agricole",
        description: "Suivez le marché, recevez des alertes et saisissez des opportunités exclusives.",
        icon: <ShopOutlined style={{ fontSize: 24, color: "#fa8c16" }} />,
        route: "/pricing/speculators"
    },
    {
        label: "Trader / Exportateur",
        description: "Accédez à des outils de trading, enchères et services d'import-export.",
        icon: <LineChartOutlined style={{ fontSize: 24, color: "#1890ff" }} />,
        route: "/pricing/traders"
    }
];

const PricingPlansImproved = () => {
    const navigate = useNavigate();

    return (
        <div style={{ padding: "40px 24px", maxWidth: 1000, margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: 40 }}>
                <Title level={2}>Choisissez votre profil</Title>
                <Text type="secondary">
                    Découvrez la tarification adaptée à votre activité sur ASSIGANTO AGRO.
                </Text>
            </div>

            <Row gutter={[32, 32]} justify="center">
                {profiles.map((profile, index) => (
                    <Col xs={24} sm={12} md={8} key={index}>
                        <Card
                            hoverable
                            style={{ textAlign: "center", borderLeft: "4px solid #f0f0f0" }}
                            actions={[
                                <Button className="application-button" onClick={() => navigate(profile.route)}>
                                    Voir les offres
                                </Button>
                            ]}
                        >
                            <div style={{ fontSize: 40, marginBottom: 16 }}>{profile.icon}</div>
                            <Title level={4}>{profile.label}</Title>
                            <Text>{profile.description}</Text>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default PricingPlansImproved;
